module.exports = __webpack_public_path__ + "img/course-10.d109a332.png";